export default __webpack_public_path__ + "static/logo2-adba4a3540fee6edd428e4502598a4ed.png";